import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import PostLink from '../components/post-link'
import BlogCard from '../components/blogCard'
import HeroHeader from '../components/heroHeader'

const SubBlogs = ({ section, edges }) => {
  const tagPost = edges
    .filter(
      (edge) =>
        !!edge.node.frontmatter.date &&
        edge.node.frontmatter.section === section
    ) // You can filter your posts based on some criteria
    .map((edge) => <BlogCard key={edge.node.id} post={edge.node} />)
  return (
    tagPost &&
    tagPost.length > 0 && (
      <div className='pt-10'>
        <h2 className="font-bold text-2xl">{section} &darr;</h2>
        <div className="grids">{tagPost}</div>
      </div>
    )
  )
}

const IndexPage = ({
  data: {
    site,
    allMarkdownRemark: { edges },
  },
}) => {
  return (
    <Layout>
      <Helmet>
        <title>{site.siteMetadata.title}</title>
        <meta name="description" content={site.siteMetadata.description} />
        <meta property="og:image" content={`${site.siteMetadata.siteUrl}/${site.siteMetadata.image}`} />
      </Helmet>
      <HeroHeader />
      <SubBlogs section="Programming" edges={edges} />
      {/* <SubBlogs section="Music" edges={edges} />
      <SubBlogs section="Test" edges={edges} /> */}
    </Layout>
  )
}

export default IndexPage
export const pageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        image
        description
        siteUrl
      }
    }
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            thumbnail
            tags
            section
            metaDescription
          }
        }
      }
    }
  }
`
